import { createFileRoute } from '@tanstack/react-router'

import { AffiliatesPage } from '@/features/affiliates/affiliates-page'
import { affiliateFilters } from '@/features/affiliates/affiliate-filters'

export const Route = createFileRoute('/_app/affiliates/')({
    validateSearch: affiliateFilters.parse,
    component: AffiliatesPage,
    staticData: { crumb: 'Affiliates' }
})
